import { ApiInstance } from '@src/services/api-instance';
import { AliareOrgSetupService } from './org-setup/aliare-org-setup-api-v1';

export class AliareV1Service {
  private readonly client: ApiInstance;

  public orgSetup: AliareOrgSetupService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/aliare-middleware/org-setup/api/v1`, client.getTimeout());

    this.orgSetup = new AliareOrgSetupService(this.client);
  }
}
